import { forceUpdate, h } from "@stencil/core";
import { scrollToTop } from "../../utils/scroll-to-top";
import { ButtonSize } from "../button/button.enum";
import { i18nProvider } from "@trumpf/ux.i18n";
export class ScrollToTopButton {
    componentWillLoad() {
        i18nProvider.subscribe(() => {
            forceUpdate(this);
        });
    }
    render() {
        const { t } = i18nProvider;
        return (h("ux-button", { key: '92646a22d9f04d010b420e5888ec78def1b54749', "aria-label": t("scrollToTop.label"), onClick: () => scrollToTop(), size: ButtonSize.Icon }, h("ux-icon", { key: '7a932a4e8c18e2cb431942ed2806c4a8db77bbd2', slot: "icon", "aria-hidden": "true", name: "arrow-up", weight: "normal" })));
    }
    static get is() { return "ux-scroll-to-top-button"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["scroll-to-top-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["scroll-to-top-button.css"]
        };
    }
}
//# sourceMappingURL=scroll-to-top-button.js.map
